module.exports = __webpack_public_path__ + "img/fsni_4.b9cd57a7.jpg";